import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import axios from '../../Actions/axios.config';

export const jobKeys = {
    all: ['jobs'],
};

export const useJobs = () => {
    return useQuery({
        queryKey: jobKeys.all,
        queryFn: async () => {
            const { data } = await axios.get('/jobs/getjob');
            return data; // jobs/getjob seems to return the list directly based on getJobs action
        },
    });
};

export const useCreateJob = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (newJob) => axios.post('/jobs/createjob', newJob),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: jobKeys.all });
        },
    });
};
